import { render, staticRenderFns } from "./ClientGroupedThreadGroup.vue?vue&type=template&id=058927b2&"
import script from "./ClientGroupedThreadGroup.vue?vue&type=script&lang=js&"
export * from "./ClientGroupedThreadGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports